<template>
    <v-row>
        <v-col cols="12">
            <base-card>
                <v-card-title>
                    {{ $t('admin.configs.title') }}
                    <!--                    <v-spacer />
                    <v-spacer />
                    <v-spacer />
                    <v-spacer />-->
                </v-card-title>

                <v-row class="mx-8">
                    <v-col
                        class="my-0 py-0"
                        cols="12"
                        md="6"
                        lg="3"
                        sm="6"
                    >
                        <v-switch
                            v-model="config.users.canRegister"
                            :label="$t('admin.configs.canRegister')"
                            @change="changeStateCanRegister($event)"
                        />
                    </v-col>

                    <v-col
                        cols="12"
                        sm="4"
                        md="3"
                        lg="2"
                    >
                        <v-datetime-picker label="Fecha fin de Reconocimientos" v-model="config.recognition.end">
                            <template v-slot:dateIcon>
                                <v-icon>mdi-calendar</v-icon>
                            </template>

                            <template v-slot:timeIcon>
                                <v-icon >mdi-clock-time-four-outline</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="4"
                        md="3"
                        lg="2"

                    >
                        <v-datetime-picker label="Fecha inicio de Votación" v-model="config.votation.start">
                            <template v-slot:dateIcon>
                                <v-icon>mdi-calendar</v-icon>
                            </template>

                            <template v-slot:timeIcon>
                                <v-icon>mdi-clock-time-four-outline</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="4"
                        md="3"
                        lg="2"

                    >
                        <v-datetime-picker label="Fecha fin de Votación" v-model="config.votation.end">
                            <template v-slot:dateIcon>
                                <v-icon>mdi-calendar</v-icon>
                            </template>

                            <template v-slot:timeIcon>
                                <v-icon>mdi-clock-time-four-outline</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="4"
                        md="3"
                        lg="2"
                    >
                        <v-datetime-picker label="Fecha fin de Competición" v-model="config.competition.end">
                            <template v-slot:dateIcon>
                                <v-icon>mdi-calendar</v-icon>
                            </template>

                            <template v-slot:timeIcon>
                                <v-icon>mdi-clock-time-four-outline</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>

                </v-row>

                <v-divider class="my-6" />

                <!--
                    Cambio de usuarios. Es la UNICA puerta a esta operacion a
                    proposito: archivar a los usuarios se lleva por cascada los
                    reconocimientos del anio, asi que antes de vaciar nada se
                    guardan la copia de seguridad y la foto de resultados de las
                    que vive la comparativa de ediciones. Tenerlo tambien en la
                    pantalla de copias significaria dos caminos para lo mismo.
                -->
                <section class="mx-8 mb-6">
                    <h3 class="text-h6 font-weight-medium mb-2">
                        {{ $t('admin.configs.annualClose.title') }}
                    </h3>
                    <p class="text-body-2 mb-2">
                        {{ $t('admin.configs.annualClose.description') }}
                    </p>
                    <p
                        v-if="status.currentEditionYear"
                        class="text-body-2 grey--text mb-4"
                    >
                        {{ $t('admin.configs.annualClose.currentYear', { year: status.currentEditionYear }) }}
                    </p>

                    <v-alert
                        v-if="destructiveBlocked"
                        type="warning"
                        dense
                        text
                    >
                        {{ $t('admin.configs.annualClose.blocked') }}
                        <span v-if="missingCapabilities.length">
                            {{ $t('admin.configs.annualClose.missingCapabilities', { caps: missingCapabilities.join(', ') }) }}
                        </span>
                    </v-alert>

                    <v-alert
                        v-if="status.locked"
                        color="orange"
                        dense
                        text
                        icon="mdi-lock-clock"
                    >
                        {{ $t('admin.configs.annualClose.locked') }}
                    </v-alert>

                    <v-btn
                        color="primary"
                        :disabled="destructiveBlocked || status.locked"
                        :loading="annualClose.processing"
                        @click="openAnnualCloseDialog"
                    >
                        {{ $t('admin.configs.annualClose.button') }}
                    </v-btn>
                </section>

                <v-dialog
                    v-model="annualClose.dialog"
                    max-width="820"
                    persistent
                    scrollable
                >
                    <v-card>
                        <v-card-title class="text-h6 error--text">
                            {{ $t('admin.configs.annualClose.dialogTitle') }}
                        </v-card-title>
                        <v-card-text>
                            <v-alert
                                type="error"
                                dense
                                text
                            >
                                {{ $t('admin.configs.annualClose.warning') }}
                            </v-alert>

                            <p class="text-body-2">
                                {{ $t('admin.configs.annualClose.intro') }}
                            </p>

                            <v-row>
                                <v-col
                                    cols="12"
                                    md="6"
                                >
                                    <div class="text-subtitle-2 error--text">
                                        {{ $t('admin.configs.annualClose.deletedTitle') }}
                                    </div>
                                    <ul class="text-body-2">
                                        <li>{{ $t('admin.configs.annualClose.deletedRecognitions') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.deletedLikes') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.deletedCloud') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.deletedTerms') }}</li>
                                    </ul>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                >
                                    <div class="text-subtitle-2 success--text">
                                        {{ $t('admin.configs.annualClose.keptTitle') }}
                                    </div>
                                    <ul class="text-body-2">
                                        <li>{{ $t('admin.configs.annualClose.keptAdmins') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.keptGroups') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.keptPosts') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.keptTerms') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.keptConfigs') }}</li>
                                        <li>{{ $t('admin.configs.annualClose.keptHistory') }}</li>
                                    </ul>
                                </v-col>
                            </v-row>

                            <v-divider class="my-4" />

                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    <v-text-field
                                        v-model.number="annualClose.closingYear"
                                        type="number"
                                        :label="$t('admin.configs.annualClose.closingYear')"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    <v-text-field
                                        v-model.number="annualClose.newYear"
                                        type="number"
                                        :label="$t('admin.configs.annualClose.newYear')"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    <v-switch
                                        v-model="annualClose.archiveUsers"
                                        :label="$t('admin.configs.annualClose.archiveUsers')"
                                    />
                                </v-col>
                            </v-row>

                            <div class="text-subtitle-2 mb-2">
                                {{ $t('admin.configs.annualClose.windowsTitle') }}
                            </div>

                            <v-row>
                                <v-col
                                    v-for="field in annualCloseDateFields"
                                    :key="field.key"
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-datetime-picker
                                        v-model="annualClose.dates[field.key]"
                                        :label="$t('admin.configs.annualClose.' + field.key)"
                                    >
                                        <template v-slot:dateIcon>
                                            <v-icon>mdi-calendar</v-icon>
                                        </template>

                                        <template v-slot:timeIcon>
                                            <v-icon>mdi-clock-time-four-outline</v-icon>
                                        </template>
                                    </v-datetime-picker>
                                </v-col>
                            </v-row>

                            <v-checkbox
                                v-model="annualClose.understood"
                                :label="$t('admin.configs.annualClose.understand')"
                                hide-details
                                class="mt-2"
                            />

                            <v-text-field
                                v-model="annualClose.confirmText"
                                class="mt-4"
                                :label="$t('admin.configs.annualClose.typeName', { name: status.databaseName })"
                                autocomplete="off"
                            />
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                text
                                :disabled="annualClose.processing"
                                @click="closeAnnualCloseDialog"
                            >
                                {{ $t('common.cancel') }}
                            </v-btn>
                            <v-btn
                                color="error"
                                :disabled="!annualCloseReady"
                                :loading="annualClose.processing"
                                @click="executeAnnualClose"
                            >
                                {{ $t('admin.configs.annualClose.confirm') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>


            </base-card>
        </v-col>
    </v-row>
</template>

<script>
import axios from '@/plugins/axios'
import { errorMessageKey, validationMessages } from '@/helpers/apiError'

// El cierre de anio vuelca la base entera antes de borrar: los 20 s por defecto
// de plugins/axios.js se agotan mucho antes de que el servidor termine.
const LONG_TIMEOUT = 600000;

// import { mapGetters } from 'vuex'

export default {
    name: "Configs",
    data: function () {
        return {
            config: this.getInitialConfig(),
            // Las tres ventanas de la edicion nueva comparten estructura, asi
            // que se pintan en bucle en vez de repetir seis veces el bloque.
            annualCloseDateFields: [
                { key: 'competitionStart' },
                { key: 'competitionEnd' },
                { key: 'recognitionStart' },
                { key: 'recognitionEnd' },
                { key: 'votationStart' },
                { key: 'votationEnd' }
            ],
            annualClose: {
                dialog: false,
                processing: false,
                closingYear: null,
                newYear: null,
                archiveUsers: true,
                dates: {},
                understood: false,
                confirmText: ''
            },
            // Lo publica GET backups/status: el nombre de la BBDD (que hay que
            // escribir para confirmar), el anio en curso y si el entorno
            // permite operaciones destructivas.
            status: {
                databaseName: '',
                destructiveAllowed: true,
                capabilities: {},
                currentEditionYear: null,
                locked: false
            },
            unwatchers: []
        }
    },
    computed: {
        // Privilegios de BBDD que faltan para poder vaciar la plataforma.
        missingCapabilities() {
            const capabilities = this.status.capabilities ?? {};

            return ['create', 'drop', 'alter', 'references']
                .filter(name => capabilities[name] === false)
                .map(name => name.toUpperCase());
        },
        destructiveBlocked() {
            return this.status.destructiveAllowed === false || this.missingCapabilities.length > 0;
        },
        annualCloseReady() {
            const allDates = this.annualCloseDateFields
                .every(field => this.annualClose.dates[field.key] instanceof Date);

            return this.annualClose.understood &&
                allDates &&
                !!this.annualClose.closingYear &&
                !!this.annualClose.newYear &&
                !!this.status.databaseName &&
                this.annualClose.confirmText === this.status.databaseName;
        }
    },
    async created() {
        await this.loadConfig();

        this.startWatchers();

        this.fetchStatus();
    },
    watch: {},
    beforeDestroy() {
        this.stopWatchers();
    },
    methods: {
        /**
         * Los watchers guardan la fecha en cuanto cambia el valor, asi que se
         * registran DESPUES de la carga inicial: si no, cargar la pantalla
         * dispararia un PATCH por cada ventana. Por el mismo motivo hay que
         * poder pararlos al recargar la configuracion tras el cierre de anio.
         */
        startWatchers() {
            this.stopWatchers();

            this.unwatchers = [
                this.$watch('config.competition.end', () => {
                    this.changeCompetition();
                }),
                this.$watch('config.recognition.end', () => {
                    this.changeRecognition();
                }),
                this.$watch('config.votation', () => {
                    this.changeVotation();
                }, {deep: true})
            ];
        },
        stopWatchers() {
            this.unwatchers.forEach(unwatch => unwatch());
            this.unwatchers = [];
        },
        getInitialConfig() {
            const config = {
                users: {canRegister: false},
                competition: {end: ""},
                recognition: {end: ""},
                votation: {start: "", end: ""}
            }
            return config;
        },
        parseConfig(id, configs) {
            const found = configs.find(current => current.id == id);

            if (found) {
                const options = found?.attributes?.options;
                try {
                    if (options.start) options.start = new Date(options.start);
                    if (options.end) options.end = new Date(options.end);
                } catch (e) {
                }

                return options;
            }
            return {};
        },
        async loadConfig() {

            try {

                const configs = await axios
                    .get('configs');

                const dataConfigs = configs?.data?.data;

                if (dataConfigs) {
                    const configs = this.getInitialConfig();

                    this.config.users = Object.assign(configs.users, this.parseConfig("1", dataConfigs));
                    this.config.competition = Object.assign(configs.competition, this.parseConfig("2", dataConfigs));
                    this.config.recognition = Object.assign(configs.recognition, this.parseConfig("3", dataConfigs));
                    this.config.votation = Object.assign(configs.votation, this.parseConfig("4", dataConfigs));

                }

            } catch (e) {
                console.log('error', e)
            }
        },

        async updateConfig(id, attributes) {

            var dataSubmit = {
                data: {
                    type: 'configs',
                    id,
                    attributes
                }
            }

            try {
                /* const result = */
                await axios({
                    method: 'patch',
                    url: `configs/${id}`,
                    data: dataSubmit
                })

                /* if (result.status === 200 || result.status === 201 || result.status === 204) {

                    const actionMSG = this.editedItem.id ? 'updatedOK' : 'createdOK'
                    this.$store.dispatch('snackbar/success', this.$t('common.' + actionMSG))
                } */
            } catch (error) {
                /* if (error.response.status === 422) {
              console.log('********** errors ********')
              console.log(error.response.data.errors)

                if (error.response?.data?.errors?.length) {

                }
            } */

                this.$store.dispatch('snackbar/error', this.$t('common.accionError'))
            }
        },
        async changeStateCanRegister() {
            const attributes = {
                name: 'users',
                options: JSON.stringify(this.config.users)
            };

            this.updateConfig('1', attributes);
        },
        async changeCompetition() {
            const value = this.config.competition.end
            const end = value instanceof Date ?
                this.dateHelper.toStringMadridTimeZone(value) : '';

            const attributes = {
                options: JSON.stringify({
                    end
                })
            };

            this.updateConfig('2', attributes);
        },
        async changeRecognition() {
            const value = this.config.recognition.end
            const end = value instanceof Date ?
                this.dateHelper.toStringMadridTimeZone(value) : '';

            const attributes = {
                options: JSON.stringify({
                    end
                })
            };

            this.updateConfig('3', attributes);
        },
        async changeVotation() {
            const valueEnd = this.config.votation.end
            const end = valueEnd instanceof Date ?
                this.dateHelper.toStringMadridTimeZone(valueEnd) : '';

            const valueStart = this.config.votation.start
            const start = valueStart instanceof Date ?
                this.dateHelper.toStringMadridTimeZone(valueStart) : '';

            const attributes = {
                options: JSON.stringify({
                    start,
                    end
                })
            };

            this.updateConfig('4', attributes);
        },
        async fetchStatus() {
            try {
                const response = await axios.get('backups/status');

                this.status = Object.assign({}, this.status, response.data ?? {});
            } catch (error) {
                // Sin estado no se puede confirmar escribiendo el nombre de la
                // BBDD, y el boton se queda deshabilitado: no hace falta gritar.
                this.status.databaseName = '';
            }
        },
        openAnnualCloseDialog() {
            const closingYear = this.status.currentEditionYear ?? new Date().getFullYear();

            this.annualClose.closingYear = closingYear;
            this.annualClose.newYear = closingYear + 1;
            this.annualClose.archiveUsers = true;
            this.annualClose.understood = false;
            this.annualClose.confirmText = '';
            this.annualClose.dates = this.defaultWindows(closingYear + 1);
            this.annualClose.dialog = true;
        },
        closeAnnualCloseDialog() {
            if (!this.annualClose.processing) {
                this.annualClose.dialog = false;
            }
        },
        /**
         * Propuesta de calendario para la edicion nueva: el anio natural
         * completo para competicion, reconocimientos hasta octubre y votacion
         * en noviembre. El administrador la puede cambiar entera.
         */
        defaultWindows(year) {
            return {
                competitionStart: new Date(year, 0, 1, 0, 0, 0),
                competitionEnd: new Date(year, 11, 31, 23, 59, 59),
                recognitionStart: new Date(year, 0, 1, 0, 0, 0),
                recognitionEnd: new Date(year, 9, 31, 23, 59, 59),
                votationStart: new Date(year, 10, 1, 0, 0, 0),
                votationEnd: new Date(year, 10, 30, 23, 59, 59)
            };
        },
        async executeAnnualClose() {
            if (!this.annualCloseReady || this.annualClose.processing) {
                return;
            }

            this.annualClose.processing = true;

            const dates = this.annualClose.dates;

            try {
                // Vaciar la plataforma es la ultima mitad de una operacion que
                // empieza guardando copia e instantanea: por eso no llama a
                // users/change, que solo archivaria a los usuarios y se llevaria
                // por cascada los reconocimientos sin dejar rastro comparable.
                const response = await axios.post('backups/reset-year', {
                    confirm: this.annualClose.confirmText,
                    closingYear: Number(this.annualClose.closingYear),
                    newYear: Number(this.annualClose.newYear),
                    archiveUsers: this.annualClose.archiveUsers,
                    competition: {
                        start: this.toBackendDate(dates.competitionStart),
                        end: this.toBackendDate(dates.competitionEnd)
                    },
                    recognition: {
                        start: this.toBackendDate(dates.recognitionStart),
                        end: this.toBackendDate(dates.recognitionEnd)
                    },
                    votation: {
                        start: this.toBackendDate(dates.votationStart),
                        end: this.toBackendDate(dates.votationEnd)
                    }
                }, { timeout: LONG_TIMEOUT });

                const data = response?.data ?? {};

                this.annualClose.dialog = false;
                this.$store.dispatch('snackbar/success', this.$t('admin.configs.annualClose.success', {
                    closingYear: data.closingYear ?? this.annualClose.closingYear,
                    newYear: data.newYear ?? this.annualClose.newYear,
                    users: data.archivedUsers ?? 0
                }));
                // Los archivados ya no estan en `users`: que ningun filtro de
                // reconocimientos siga tirando de la lista de antes.
                this.$store.commit('cacheRecognitios/clearUsers');

                await this.reloadConfigWithoutSaving();
                await this.fetchStatus();
            } catch (error) {
                this.$store.dispatch('snackbar/error', this.resolveError(error, 'admin.configs.annualClose.error'));
            } finally {
                this.annualClose.processing = false;
            }
        },
        /**
         * El cierre reescribe las tres ventanas de fechas, asi que la pantalla
         * tiene que volver a leerlas. Con los watchers vivos, cargarlas
         * dispararia un PATCH por cada una devolviendo al servidor lo que
         * acaba de escribir el propio cierre.
         */
        async reloadConfigWithoutSaving() {
            this.stopWatchers();

            await this.loadConfig();
            await this.$nextTick();

            this.startWatchers();
        },
        /**
         * El backend distingue fallos que el administrador resuelve de forma
         * distinta: esperar (423), leer el motivo (409) o pedir que se habiliten
         * las operaciones destructivas (403).
         */
        resolveError(error, fallbackKey) {
            const response = error?.response;
            const status = response?.status;

            if (status === 423) {
                return this.$t('admin.configs.annualClose.locked');
            }

            if (status === 403) {
                return this.$t('admin.configs.annualClose.blocked');
            }

            if (status === 422) {
                const messages = validationMessages(error);

                if (messages.length) {
                    return messages.join(' ');
                }
            }

            if (!response) {
                return this.$t(errorMessageKey(error));
            }

            return response?.data?.message ?? this.$t(fallbackKey);
        },
        /**
         * El contrato pide 'YYYY-MM-DD HH:mm:ss' en hora de Madrid, que es justo
         * lo que devuelve el locale sueco (mismo criterio que el resto de esta
         * pantalla).
         */
        toBackendDate(value) {
            return value instanceof Date ? this.dateHelper.toStringMadridTimeZone(value) : null;
        }
    }
};
</script>
